import * as React from 'react'
import MenuItem from '@mulesoft/anypoint-components/lib/MenuItem'
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip'
import Popover from '@mulesoft/anypoint-components/lib/Popover'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import Menu from '@mulesoft/anypoint-components/lib/Menu'
import { isNullOrUndefined } from 'util'
import './NewAlertDropdown.css'

export type ValueProps = {
  isTitanium: boolean
  isLandingPage: boolean
  isBasicAlertsEnabled: boolean
  organizationDomain: string
  className?: string
  disabled?: boolean
}

export type EventProps = {
  handleOpenBasicAlertModal: () => void
  handleOpenAdvancedAlertModal: () => void
}

export type Props = ValueProps & EventProps

export default class NewAlertDropdown extends React.Component<Props> {

  otherLinkRedirect(url: string) {
    return () => window.location.href = url
  }

  render() {
    const {isTitanium, isLandingPage, isBasicAlertsEnabled, organizationDomain, disabled} = this.props
    const showOtherOptions = !isTitanium || (isTitanium && !isLandingPage)

    return (
      <div id={'new-alert-dropdown'} className={disabled ? 'disabled' : ''} data-test-id="new-alert-dropdown-container">
        <Popover
          triggerOn={['click']}
          closeOnClickInside={true}
          closeOnClickOutside={true}
          anchorPosition={'br'}
          popupPosition={'tr'}
          testId={'new-alert-dropdown'}
          content={
            <Menu className={`new-alert-dropdown-menu`} testId={'new-alert-dropdown-menu'}>

              {isBasicAlertsEnabled && <MenuItem
                testId={'new-alert-dropdown-menu-item-basic-alert'}
                key={'new-alert-dropdown-menu-item-basic-alert'}
                onClick={this.onClick(this.props.handleOpenBasicAlertModal)}
              >
                <div className={'new-alert-dropdown-menu-item-title'} data-test-id="new-alert-dropdown-menu-item-basic-alert-title">
                  <span className={'new-alert-dropdown-menu-item-title'}>Basic alert</span>
                  <div className={'new-alert-dropdown-menu-item-new-tag'} data-test-id="new-alert-dropdown-menu-item-new-tag">
                    <span>New</span>
                  </div>
                </div>
                <span className={'new-alert-dropdown-menu-item-subtitle'} data-test-id="new-alert-dropdown-menu-item-basic-alert-subtitle">
                  Create basic alerts for applications and servers from Anypoint Monitoring
                </span>

              </MenuItem>}

              {isTitanium && <MenuItem
                testId={'new-alert-dropdown-menu-item-advanced-alert'}
                key={'new-alert-dropdown-menu-item-advanced-alert'}
                onClick={this.onClick(this.props.handleOpenAdvancedAlertModal)}
              >
                <span className={'new-alert-dropdown-menu-item-title'} data-test-id="new-alert-dropdown-menu-item-advanced-alert-title">
                  Advanced alert
                </span>
                <span className={'new-alert-dropdown-menu-item-subtitle'} data-test-id="new-alert-dropdown-menu-item-advanced-alert-subtitle">
                  Learn how to create advanced alerts in Anypoint monitoring using custom dashboards
                </span>
              </MenuItem>}

              {showOtherOptions && <MenuItem
                testId={'new-alert-dropdown-menu-item-other'}
                key={'new-alert-dropdown-menu-item-other'}
              >
                <span className={'new-alert-dropdown-menu-item-title'} data-test-id="new-alert-dropdown-menu-item-other-title">
                  Other
                </span>
                <a
                  className={'new-alert-dropdown-menu-item-subtitle'}
                  data-test-id="new-alert-dropdown-menu-item-api-manager-subtitle"
                  onClick={this.otherLinkRedirect(`/apimanager/${organizationDomain}/#/login`)}
                >
                  <IconPanel className={'popover-icon'} name={'link-small'} fill={'#3A3B3C'} size={12} testId="popover-icon"/>
                  <span data-test-id="new-alert-dropdown-menu-item-api-manager-subtitle-text">
                    Create an alert for your API in API manager
                  </span>
                </a>
                <a
                  className={'new-alert-dropdown-menu-item-subtitle'}
                  data-test-id="new-alert-dropdown-menu-item-runtime-manager-subtitle"
                  onClick={this.otherLinkRedirect('/cloudhub/#/console/home/alerts')}
                >
                  <IconPanel className={'popover-icon'} name={'link-small'} fill={'#3A3B3C'} size={12} testId="popover-icon"/>
                  <span data-test-id="new-alert-dropdown-menu-item-runtime-manager-subtitle-text">
                    Create an alert for your server in Runtime manager
                  </span>
                </a>
              </MenuItem>}
            </Menu>}
        >
          <span data-test-id="new-alert-dropdown-content">
            <IconPanel
              className={'new-alert-dropdown-content-icon'}
              name={'plus-small'}
              fill={'#FFFFFF'}
              size={15}
              testId="new-alert-dropdown-content-plus-icon"
            />
            <span data-test-id="new-alert-dropdown-content-text">New alert</span>
            <IconPanel
              className={'new-alert-dropdown-content-icon'}
              name={'arrow-down-small'}
              fill={'#FFFFFF'}
              size={15}
              testId="new-alert-dropdown-content-arrow-down-icon"
            />
          </span>
        </Popover>
      </div>

    )
  }

  onClick(f: () => void) {
    return () => {
      f()
      // workaround because the 'closeOnClickInside' property doesn't work
      const newAlertDropdown = document.querySelector('#new-alert-dropdown > span > div') as HTMLElement
      if (!isNullOrUndefined(newAlertDropdown)) {
        newAlertDropdown.click()
      }
    }
  }
}
